import React from 'react';
import LoginForm from '../components/Auth/LoginForm';

export default function LoginPage() {
  return (
    <div>
      <LoginForm />
    </div>
  );
}